import React, { FC, useState, useEffect, useMemo } from 'react';

import cn from 'classnames';
import { useMenu } from 'react-instantsearch-hooks-web';

import { lettersArray } from './const';
import useStyles from './styles';

interface IndexMenuProps {
  attribute: string;
  limit?: number;
}

const IndexMenu: FC<IndexMenuProps> = ({ attribute, limit }) => {
  const classes = useStyles();

  const { items, refine } = useMenu({ attribute, limit });

  const [hasRefined, setHasRefined] = useState(false);
  const normalizedItems = useMemo(() => {
    const obj = {};
    items.forEach((item) => {
      obj[item.label] = item;
    });

    return obj;
  }, [items]);

  useEffect(() => {
    setHasRefined(!!items.filter((item) => item.isRefined).length);
  }, [items]);

  return (
    <div className={classes.wrapper}>
      <div
        key="all"
        className={cn(classes.index, !hasRefined && classes.active)}
        onClick={() => refine('')}
      >
        All
      </div>
      {lettersArray.map((item) => {
        const exists = item in normalizedItems;
        return (
          <div
            key={item}
            className={cn(
              classes.index,
              exists ? normalizedItems[item].isRefined && classes.active : classes.disabled,
            )}
            onClick={exists ? () => refine(normalizedItems[item].value) : () => {}}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
};

export default IndexMenu;
